"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styled = _interopRequireWildcard(require("./PhrasingLoading.styles"));
var _SpotIllustrationSection = _interopRequireDefault(require("./SpotIllustrationSection"));
var _PhraseSection = _interopRequireDefault(require("./PhraseSection"));
var _ProgressSection = _interopRequireDefault(require("./ProgressSection"));
var _ErrorSection = _interopRequireDefault(require("./ErrorSection"));
var _constants = require("./constants");
var _useStateMachine2 = require("./useStateMachine");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable @typescript-eslint/no-empty-function */

var PhrasingLoading = function PhrasingLoading(_ref) {
  var illustration = _ref.illustration,
    imageAlt = _ref.imageAlt,
    light = _ref.light,
    steps = _ref.steps,
    hasError = _ref.hasError,
    isLoading = _ref.isLoading,
    _ref$loadingTimeout = _ref.loadingTimeout,
    loadingTimeout = _ref$loadingTimeout === void 0 ? _constants.DEFAULT_LOADING_TIMEOUT : _ref$loadingTimeout,
    _ref$onRetryButtonCli = _ref.onRetryButtonClick,
    onRetryButtonClick = _ref$onRetryButtonCli === void 0 ? function () {} : _ref$onRetryButtonCli,
    _ref$onLoadingFinish = _ref.onLoadingFinish,
    onLoadingFinish = _ref$onLoadingFinish === void 0 ? function () {} : _ref$onLoadingFinish,
    _ref$onLoadingTimeout = _ref.onLoadingTimeout,
    onLoadingTimeout = _ref$onLoadingTimeout === void 0 ? function () {} : _ref$onLoadingTimeout;
  if (steps.length < 2) throw new Error('Invalid props. You must have at least 2 steps');
  if (steps.length > 5) throw new Error('Invalid props. You must have at most 5 steps');
  var _useStateMachine = (0, _useStateMachine2.useStateMachine)(steps, onLoadingFinish, loadingTimeout, onLoadingTimeout, isLoading),
    isLastStep = _useStateMachine.isLastStep,
    stepCount = _useStateMachine.currentStep,
    timeoutError = _useStateMachine.timeoutError,
    showSecondLastStep = _useStateMachine.showSecondLastStep;
  return /*#__PURE__*/_react["default"].createElement(Styled.PhrasingLoadingWrapper, {
    container: true,
    $light: light
  }, hasError || timeoutError ? /*#__PURE__*/_react["default"].createElement(_ErrorSection["default"], {
    onButtonClick: onRetryButtonClick,
    light: light
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SpotIllustrationSection["default"], {
    name: illustration,
    alt: imageAlt,
    finalStep: isLastStep
  }), /*#__PURE__*/_react["default"].createElement(Styled.PhrasingLoadingContentWrapper, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/_react["default"].createElement(_PhraseSection["default"], {
    steps: steps,
    light: light,
    stepCount: stepCount,
    showSecondLastStep: showSecondLastStep
  }), /*#__PURE__*/_react["default"].createElement(_ProgressSection["default"], {
    progressValue: 100 * stepCount / steps.length,
    light: light
  }))));
};
PhrasingLoading.propTypes = process.env.NODE_ENV !== "production" ? {
  illustration: _propTypes["default"].string,
  imageAlt: _propTypes["default"].string,
  light: _propTypes["default"].bool,
  onLoadingTimeout: _propTypes["default"].func,
  steps: _propTypes["default"].array.isRequired,
  hasError: _propTypes["default"].bool,
  onRetryButtonClick: _propTypes["default"].func
} : {};
var _default = exports["default"] = PhrasingLoading;